import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { noop } from 'lodash';
import classnames from 'classnames';
import ActionButton from '../action-button/action-button';
import ActionButtonLabel from '../action-button-label/action-button-label';
import ActionButtonIcon from '../action-button-icon/action-button-icon';
import Animate from '../../../ui-components/animate/animate';
import { OWNERSHIP_STATUSES } from '../../../ui-selectors/video-access';
import styles from './actions-panel.scss';
class ActionsPanel extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "show", () => {
      this.setState({
        isMainContentHidden: false
      });
    });
    _defineProperty(this, "hide", () => {
      this.setState({
        isMainContentHidden: true
      });
    });
    _defineProperty(this, "handleAllCardsButtonClick", event => {
      const {
        onAllCardsButtonClick,
        pauseVideo
      } = this.props;
      pauseVideo();
      onAllCardsButtonClick(event);
    });
    _defineProperty(this, "handleCommentsButtonClick", () => {
      const {
        onCommentsButtonClick
      } = this.props;
      onCommentsButtonClick();
    });
    _defineProperty(this, "onBuyRentButtonClick", event => {
      const {
        pauseVideo,
        exitFullScreen,
        onBuyRentButtonClick
      } = this.props;
      if (onBuyRentButtonClick) {
        pauseVideo();
        exitFullScreen();
        onBuyRentButtonClick(event);
      }
    });
    this.state = {
      isMainContentHidden: props.isControlsShown
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.shouldMainContentBeHidden(nextProps);
  }
  shouldMainContentBeHidden(nextProps) {
    const {
      isMainContentHidden
    } = this.state;
    const {
      isControlsShown
    } = nextProps;
    if (isControlsShown) {
      if (isMainContentHidden) {
        this.show();
      }
    } else {
      this.hide();
    }
  }
  getBuyRentIconName() {
    switch (this.props.videoOwnershipStatus) {
      case OWNERSHIP_STATUSES.YOU_BOUGHT_THIS:
        return 'film';
      case OWNERSHIP_STATUSES.YOU_RENTED_THIS:
        return 'timer';
      default:
        return 'dollar';
    }
  }
  render() {
    const {
      areElementsRounded,
      canShowBuyRentButton,
      canShareVideo,
      canShowFullInfo,
      canShowAllCardsButton,
      canShowCommentsButton,
      buyRentButtonText,
      videoInfoFullText,
      videoInfoShortText,
      shareVideoFullText,
      shareVideoShortText,
      showAllCardsFullText,
      commentsFullText,
      commentsShortText,
      showAllCardsShortText,
      infoButtonAriaLabel,
      shareButtonAriaLabel,
      allCardsButtonAriaLabel,
      commentsButtonAriaLabel,
      onVideoInfoShow,
      onShareVideoShow,
      isFocusable,
      shouldShowCommentsPimple,
      isRTL
    } = this.props;
    const {
      isMainContentHidden
    } = this.state;
    const rtlClassConfig = {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    };
    const actionButtonClasses = classnames(styles.actionButton, rtlClassConfig);
    return /*#__PURE__*/React.createElement("section", {
      className: styles['main-content-wrapper'],
      "data-hook": "player-overlay-actions"
    }, /*#__PURE__*/React.createElement(Animate, {
      type: "fade-in-out",
      className: styles['main-content'],
      when: !isMainContentHidden
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['main-content-inner']
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.actions, rtlClassConfig)
    }, canShowBuyRentButton && /*#__PURE__*/React.createElement(ActionButton, {
      className: classnames(actionButtonClasses, styles['buy-rent-button'], {
        [styles['with-label']]: buyRentButtonText
      }),
      dataHook: "paid-access-button",
      isFocusable: isFocusable,
      onClick: this.onBuyRentButtonClick,
      rounded: areElementsRounded
    }, buyRentButtonText && /*#__PURE__*/React.createElement(ActionButtonLabel, {
      className: styles['button-label'],
      label: buyRentButtonText
    }), /*#__PURE__*/React.createElement(ActionButtonIcon, {
      icon: this.getBuyRentIconName()
    })), canShowFullInfo && /*#__PURE__*/React.createElement(ActionButton, {
      className: classnames(actionButtonClasses, styles.animatedButton, styles['video-info-button']),
      dataHook: "video-info-button",
      isFocusable: isFocusable,
      onClick: onVideoInfoShow,
      ariaLabel: infoButtonAriaLabel,
      rounded: areElementsRounded
    }, videoInfoFullText && /*#__PURE__*/React.createElement(ActionButtonLabel, {
      className: styles['button-label'],
      label: videoInfoFullText,
      shortLabel: videoInfoShortText
    }), /*#__PURE__*/React.createElement(ActionButtonIcon, {
      icon: "info"
    })), canShareVideo && /*#__PURE__*/React.createElement(ActionButton, {
      className: classnames(actionButtonClasses, styles.animatedButton, styles['share-button']),
      dataHook: "share-button",
      isFocusable: isFocusable,
      onClick: onShareVideoShow,
      ariaLabel: shareButtonAriaLabel,
      rounded: areElementsRounded
    }, shareVideoFullText && /*#__PURE__*/React.createElement(ActionButtonLabel, {
      className: styles['button-label'],
      label: shareVideoFullText,
      shortLabel: shareVideoShortText
    }), /*#__PURE__*/React.createElement(ActionButtonIcon, {
      icon: "share"
    })), canShowAllCardsButton && /*#__PURE__*/React.createElement(ActionButton, {
      className: classnames(actionButtonClasses, styles.animatedButton, styles['all-cards-button']),
      dataHook: "all-cards-button",
      isFocusable: isFocusable,
      onClick: this.handleAllCardsButtonClick,
      ariaLabel: allCardsButtonAriaLabel,
      rounded: areElementsRounded
    }, showAllCardsFullText && /*#__PURE__*/React.createElement(ActionButtonLabel, {
      className: styles['button-label'],
      label: showAllCardsFullText,
      shortLabel: showAllCardsShortText
    }), /*#__PURE__*/React.createElement(ActionButtonIcon, {
      icon: "spark"
    })), canShowCommentsButton && /*#__PURE__*/React.createElement(ActionButton, {
      className: classnames(actionButtonClasses, styles.animatedButton, styles['chat-button']),
      dataHook: "chat-button",
      isFocusable: isFocusable,
      onClick: this.handleCommentsButtonClick,
      ariaLabel: commentsButtonAriaLabel,
      rounded: areElementsRounded
    }, commentsFullText && /*#__PURE__*/React.createElement(ActionButtonLabel, {
      className: styles['button-label'],
      label: commentsFullText,
      shortLabel: commentsShortText
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['chat-big']
    }, /*#__PURE__*/React.createElement(ActionButtonIcon, {
      icon: "chatBig"
    })), /*#__PURE__*/React.createElement("div", {
      className: styles['chat-small']
    }, /*#__PURE__*/React.createElement(ActionButtonIcon, {
      icon: "chatSmall"
    })), shouldShowCommentsPimple && /*#__PURE__*/React.createElement("div", {
      className: styles['chat-pimple']
    }))))));
  }
}
_defineProperty(ActionsPanel, "defaultProps", {
  onAllCardsButtonClick: noop,
  onBuyRentButtonClick: noop,
  onVideoInfoShow: noop,
  onShareVideoShow: noop,
  pauseVideo: noop,
  exitFullScreen: noop,
  isControlsShown: true
});
export default ActionsPanel;
//# sourceMappingURL=actions-panel.js.map